import React from 'react'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Mandator } from '@professocialApi/professocial-core-frontend-api/models/Mandator'

type Props = {
  mandatorOptions?: Mandator
}

const ConnectedPages: React.FC<Props> = ({ mandatorOptions }) => {
  const { t } = useTranslation()

  const {
    connectedFacebookPages = 0,
    connectedInstagramPages = 0,
    connectedLinkedInPages = 0,
    connectedGoogleMyBusinessPages = 0,
    licensePermissions,
  } = { ...mandatorOptions }

  const generalCount =
    connectedFacebookPages +
    connectedInstagramPages +
    connectedLinkedInPages +
    connectedGoogleMyBusinessPages

  return (
    <>
      <Typography sx={{ p: 2 }} variant="body2">
        {t('accountsCommon:connectedGeneral')}: {generalCount}/{licensePermissions?.pageLimitGeneral}
      </Typography>
      {licensePermissions?.canUseFacebook && (
        <Typography sx={{ p: 2 }} variant="body2">
          {t('accountsCommon:connectedFacebookPages')}: {connectedFacebookPages}/{licensePermissions.pageLimitFacebook}
        </Typography>
      )}
      {licensePermissions?.canUseInstagram && (
        <Typography sx={{ p: 2 }} variant="body2">
          {t('accountsCommon:connectedInstagramPages')}: {connectedInstagramPages}/{licensePermissions.pageLimitInstagram}
        </Typography>
      )}
      {licensePermissions?.canUseLinkedIn && (
        <Typography sx={{ p: 2 }} variant="body2">
          {t('accountsCommon:connectedLinkedInPages')}: {connectedLinkedInPages}/{licensePermissions.pageLimitLinkedIn}
        </Typography>
      )}
      {licensePermissions?.canUseGoogleMyBusiness && (
        <Typography sx={{ p: 2 }} variant="body2">
          {t('accountsCommon:connectedGoogleMyBusinessPages')}: {connectedGoogleMyBusinessPages}/{licensePermissions.pageLimitGoogleMyBusiness}
        </Typography>
      )}
    </>
  )
}

export default ConnectedPages
